import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { UnifiedPrivacy } from '@prezi/presentation-service-client';
import { actions } from '../../../store/actions/actions';
import { fixViewLinkOwnPermissionWithLimit, isPermissionAllowed, isPermissionNotAllowedBecauseLimitReached, isPermissionNotAllowedInOrg } from '../../../api/userPermissions';
import * as Dumb from '../dumb';
import { getGlassboxLogger } from '../../../glassboxLogger';
import { useConfig } from '../../../utils/config';
import analyticsControlContextSelector from '../../screens/ViewLinksPage/analyticsControlContextSelector';
const createControlContextSelector = state => {
  var _state$unifiedPrivacy, _state$userPermission;
  const isDocumentClosed = ((_state$unifiedPrivacy = state.unifiedPrivacy.value) === null || _state$unifiedPrivacy === void 0 ? void 0 : _state$unifiedPrivacy.unified_privacy) === UnifiedPrivacy.unified_privacy.CLOSED;
  if (isDocumentClosed) {
    return {
      disabled: true,
      reason: 'notAllowedClosedPrivacy'
    };
  }
  const linkCount = state.viewlinks.value.allIds.length;
  const viewLinkOwnPermission = fixViewLinkOwnPermissionWithLimit(linkCount, (_state$userPermission = state.userPermissions.value) === null || _state$userPermission === void 0 ? void 0 : _state$userPermission.viewLink.own);
  if (isPermissionNotAllowedInOrg(viewLinkOwnPermission === null || viewLinkOwnPermission === void 0 ? void 0 : viewLinkOwnPermission.create)) {
    return {
      disabled: true,
      reason: 'notAllowedInOrg'
    };
  }
  if (isPermissionNotAllowedBecauseLimitReached(viewLinkOwnPermission === null || viewLinkOwnPermission === void 0 ? void 0 : viewLinkOwnPermission.create)) {
    var _viewLinkOwnPermissio;
    return {
      disabled: true,
      paywall: {
        reason: 'notAllowedLimitReached',
        missingFeature: viewLinkOwnPermission === null || viewLinkOwnPermission === void 0 ? void 0 : (_viewLinkOwnPermissio = viewLinkOwnPermission.create.missing_features) === null || _viewLinkOwnPermissio === void 0 ? void 0 : _viewLinkOwnPermissio.features.at(0),
        logger: () => getGlassboxLogger().logLoadedPaywallCta({
          cta_paywall_type: 'SECOND_VIEW_LINK',
          paywall_cta_product: 'PRESENT'
        })
      }
    };
  }
  return {
    disabled: false
  };
};
const manageControlContextSelector = state => {
  var _state$userPermission2, _state$userPermission3;
  const linkCount = state.viewlinks.value.allIds.length;
  const viewLinkOwnPermission = fixViewLinkOwnPermissionWithLimit(linkCount, (_state$userPermission2 = state.userPermissions.value) === null || _state$userPermission2 === void 0 ? void 0 : _state$userPermission2.viewLink.own);
  const isUpdatingAllowed = isPermissionAllowed(viewLinkOwnPermission === null || viewLinkOwnPermission === void 0 ? void 0 : viewLinkOwnPermission.update) || isPermissionAllowed((_state$userPermission3 = state.userPermissions.value) === null || _state$userPermission3 === void 0 ? void 0 : _state$userPermission3.viewLink.all.update);
  if (!isUpdatingAllowed) {
    return {
      disabled: true,
      reason: 'notAllowedShared'
    };
  }
  return {
    disabled: false
  };
};
const TrackableLinksOverview = ({
  isShareLinkImprovementsActive
}) => {
  const {
    onUpgrade
  } = useConfig();
  const dispatch = useDispatch();
  const createControlContext = useSelector(createControlContextSelector);
  const manageControlContext = useSelector(manageControlContextSelector);
  const shouldBeShown = useSelector(state => {
    var _state$document$value, _state$userPermission4, _state$document$value2, _state$userPermission5, _state$featureSwitche;
    return ((_state$document$value = state.document.value) === null || _state$document$value === void 0 ? void 0 : _state$document$value.schema_version_name) === 'PITCH' && ((_state$userPermission4 = state.userPermissions.value) === null || _state$userPermission4 === void 0 ? void 0 : _state$userPermission4.viewLink.base) || ((_state$document$value2 = state.document.value) === null || _state$document$value2 === void 0 ? void 0 : _state$document$value2.schema_version_name) === 'INFOGRAM' && ((_state$userPermission5 = state.userPermissions.value) === null || _state$userPermission5 === void 0 ? void 0 : _state$userPermission5.viewLink.base) && ((_state$featureSwitche = state.featureSwitches.value) === null || _state$featureSwitche === void 0 ? void 0 : _state$featureSwitche['prezi-design-analytics-viewlinks']);
  });
  const linkCount = useSelector(state => state.viewlinks.value.allIds.length);
  const analyticsControlContext = useSelector(analyticsControlContextSelector);
  const hasShareLinkAccess = !analyticsControlContext.paywall;
  return shouldBeShown ? React.createElement(Dumb.TrackableLinksOverview, {
    onClick: () => isShareLinkImprovementsActive && !hasShareLinkAccess ? onUpgrade('pitch_analytics') : dispatch(actions.setPage('viewLinks')),
    linkCount: linkCount,
    createControlContext: createControlContext,
    manageControlContext: manageControlContext,
    hasShareLinkAccess: hasShareLinkAccess,
    isShareLinkImprovementsActive: isShareLinkImprovementsActive
  }) : null;
};
export default TrackableLinksOverview;